import FeeTypeContainer from '../../../containers/FeeTypeContainer'

const FeeTypes = () => <FeeTypeContainer />

export default FeeTypes